import axios from "axios";
import {addToState, getState} from "./stateController";

axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {

    const originalRequest = error.config;

    if (error.response.status === 401 && !originalRequest._retry && getState().role === "host") {

        originalRequest._retry = true;

        return axios.post(global.API_URL + "/refresh-token", {
            "token": getState().apiToken
        })
            .then(({data}) => {
                addToState({access_token: data.access_token})
                originalRequest.headers['Authorization'] = 'Bearer ' + data.access_token;
                return axios(originalRequest);
            });
    }

    return Promise.reject(error);
});


export async function getDevices(token: string) {
    return fetch(`https://api.spotify.com/v1/me/player/devices`, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
        method: 'GET',
    }).then((d) => d.json());
}


export async function setDevice(token: string, deviceId: string, shouldPlay?: boolean | undefined) {
    return fetch(`https://api.spotify.com/v1/me/player`, {
        body: JSON.stringify({ device_ids: [deviceId], play: shouldPlay }),
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
        method: 'PUT',
    });
}

export async function playNextSong(albumUri, albumOffset, update=true) {
    if(albumUri === "") {
        return;
    }

    axios.put(`https://api.spotify.com/v1/me/player/play?device_id=${getState().device_id}`, {
            "context_uri":  albumUri,
            "offset": {
                "position": albumOffset
            },
        },
        {
            headers: {
                Authorization: `Bearer ${getState().access_token}`,
                'Content-Type': 'application/json',
            },
        }
    ).then(() => {
        if (update !== false) {
            axios.post(global.API_URL + "/update-queue", {
                "token": getState().apiToken
            }).catch(error => console.log(error));
        }
    }).catch((e) => {
        console.log(e)
    })
}